import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData,
  type RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchError,
  type RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchResponse,
  renameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatch,
} from '../../generated';

export type RenameCollectionMutationVariables =
  RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData['path'] &
    RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData['body'];

export type RenameCollectionMutation =
  RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchResponse;

export const useRenameCollectionMutation = <
  TError = RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<RenameCollectionMutation, TError, RenameCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<RenameCollectionMutation, TError, RenameCollectionMutationVariables, TContext>({
    mutationKey: ['RenameCollection'],
    mutationFn: async ({ workspace_id, collection_id, name }: RenameCollectionMutationVariables) => {
      const { data } = await renameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatch({
        path: { workspace_id, collection_id },
        body: { name },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useRenameCollectionMutation.fetcher = (
  { workspace_id, collection_id, name }: RenameCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await renameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatch({
      path: { workspace_id, collection_id },
      body: { name },
      throwOnError: true,
    });
    return data;
  };
};
